import { required } from 'ra-core';
import { TextInput } from '../../components/admin/text-input';
import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { SimpleStack } from '../Moonstar/SimpleStack';

export const UnitEdit = () => (
  <MoonstarEdit redirect="list">
    <MoonstarEditForm>
      <SimpleStack>
        <TextInput source="name" validate={required()} />
      </SimpleStack>
    </MoonstarEditForm>
  </MoonstarEdit>
);
